var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatEmojii = function SvgChatEmojii(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M7.502 12.004a4.507 4.507 0 0 1 4.5-4.5 4.506 4.506 0 0 1 4.5 4.5 4.507 4.507 0 0 1-4.5 4.5 4.508 4.508 0 0 1-4.5-4.5zm.817 0a3.686 3.686 0 0 0 3.683 3.686 3.686 3.686 0 0 0 3.684-3.686 3.68 3.68 0 0 0-3.684-3.674 3.68 3.68 0 0 0-3.684 3.674zm.767.855a.376.376 0 0 1 .074-.346.416.416 0 0 1 .334-.154h5.017a.452.452 0 0 1 .353.166.335.335 0 0 1 .056.334 3.041 3.041 0 0 1-2.917 1.943 3.041 3.041 0 0 1-2.918-1.946zm2.916 1.168a2.281 2.281 0 0 0 1.846-.9h-3.69a2.282 2.282 0 0 0 1.844.897z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatEmojii);
export default ForwardRef;